import { TableRowProps } from "../../molecules/TableRow/TableRowAtom";
import { ItemsTable } from "../../network/models/TableInterfaces";
import {
  createInfoCell,
  createClickableCell,
  createCurrencyCell,
} from "../../utilities/CreateCell";
import { createRow } from "../../utilities/CreateRow";

export const createItemsRows = (
  data: Array<ItemsTable>,
  deleteHandler: (itemId: string) => void,
  returnRequestStatus: any,
  setEditingItem: (item: ItemsTable | null) => void
) => {
  const rows: Array<TableRowProps> = [];

  data.forEach((entry) => {
    const isFull = entry.fullQuantity !== 0;
    const row: TableRowProps = createRow(
      createInfoCell(entry.ndc), //NDC
      createInfoCell(entry.description), //Description
      createInfoCell(entry.manufacturer), //Manufacturer
      createInfoCell(entry.strength), //Strength
      createInfoCell(entry.dosage), //Dosage
      createInfoCell(entry.lotNumber), //Lot Number
      createInfoCell(entry.expirationDate), //Expiration Date
      createInfoCell(entry.packageSize.toString()), //Pkg Size
      //createInfoCell(entry.gtin14), //GTIN
      //createInfoCell(entry.serialNumber), //Serial Number
      createInfoCell(entry.controlledSubstanceCode), //Controlled Substance Code
      createInfoCell(
        entry.fullQuantity
          .toString(10)
          .concat(
            entry.fullQuantity !== 0
              ? entry.isFullQuantityOpened
                ? " F/O"
                : " F/S"
              : ""
          )
      ), //Full Quantity
      createInfoCell(
        entry.partialQuantity
          .toString(10)
          .concat(
            entry.partialQuantity !== 0
              ? " " + entry.packageSize.toString().split(" ")[1]
              : ""
          )
      ), //Partial Quantity
      createCurrencyCell(
        isFull
          ? (parseFloat(entry.extendedActualPrice) !== 0 ? entry.extendedActualPrice : parseFloat(entry.extendedPrice) * 0.7)
          : (parseFloat(entry.extendedUnitActualPrice) !== 0 ? entry.extendedUnitActualPrice : parseFloat(entry.extendedUnitPrice) * 0.7)
      ),
      returnRequestStatus === "DRAFT" || returnRequestStatus !== "SENT"
        ? createClickableCell(() => deleteHandler('' + entry.id), "Remove")
        : "",
      createClickableCell(() => setEditingItem(entry), "Edit")
    );

    rows.push(row);
  });
  return rows;
};
